import React from 'react';

import './ColumnsLayout.scss';

function ColumnsLayout(props) {
  return <div styleName="container">{props.children}</div>;
}

export default React.memo(ColumnsLayout);
